import { Component } from '@angular/core';

@Component({
  templateUrl: './subscriptions-page.component.html',
  styleUrls: ['./subscriptions-page.component.scss']
})
export class SubscriptionsPageComponent{

  www = "16.6%";

}
